
















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Dropdown extends Vue {
	@Prop({ type: String, required: true, default: "下拉" })
	title!: string;

    @Prop({ type: Boolean, default: true })
    plain?: string;

    @Prop({ type: String, default: "" })
	type!: string;

	@Prop({ type: Array, required: true, default: [] })
	itemList!: any[] | { id: string; value: string | number }[];

	@Prop({ type: String })
    valueKey?: string;

    change(e: string | number) {
        this.$emit("command", e);
    }
}
